"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class BreadcrumbStore {
    constructor() {
        this.breadcrumbs = new Map();
        this.listenersByConsumerId = new Map();
    }
    get(consumerId) {
        return this.breadcrumbs.get(consumerId) || [];
    }
    update(consumerId, breadcrumbs) {
        this.breadcrumbs.set(consumerId, breadcrumbs);
        for (const listeners of this.listenersByConsumerId.values()) {
            for (const listener of listeners) {
                listener(consumerId, breadcrumbs);
            }
        }
    }
    listen(consumerId, listener) {
        const listeners = this.getListenersForConsumerId(consumerId);
        listeners.add(listener);
        return () => listeners.delete(listener);
    }
    unlisten(consumerId) {
        this.getListenersForConsumerId(consumerId).clear();
    }
    getListenersForConsumerId(consumerId) {
        let listeners = this.listenersByConsumerId.get(consumerId);
        if (!listeners) {
            listeners = new Set();
            this.listenersByConsumerId.set(consumerId, listeners);
        }
        return listeners;
    }
}
exports.BreadcrumbStore = BreadcrumbStore;
//# sourceMappingURL=breadcrumb-store.js.map